import { TranslationItemModel } from '@/api/BaseAPI.model'

type IngredientModel = {
  id: string
  translations: TranslationItemModel[]
  allergenIds: string[]
  unitId: string
  quantity: number
  pricePerUnit: {
    unitId: string
    price: number
  }
}

type ReducedIngredientModel = {
  id: string
  unit: {
    id: string
    quantity: number
  }
}

type IngredientByDishSizeIdModel = {
  id: string
  ingredients: ReducedIngredientModel[]
}

type DishModel = {
  id?: string
  price: number
  priceToDishSizeId: {
    id: string
    price: number
  }[]
  ingredients: IngredientModel[]
  ingredientsByDishSizeId: IngredientByDishSizeIdModel[]
  menuNumber: number
  translations: TranslationItemModel[]
  dishToppingIds: string[]
  dishMenuTypeIds: string[]
  dishCategoryIds: string[]
  dishSizeIds: string[]
  allergenIds: string[]
  dietId: string | null
  spiceLevelId: string | null
}

type DishSizesModel = {
  id?: string
  translations: TranslationItemModel[]
  relatedItems?: TranslationItemModel[]
}[]

type ToppingsModel = {
  id?: string
  price: number
  translations: TranslationItemModel[]
  dishCategoryIds: string[]
}[]

enum QUERY {
  DISH = 'DISH',
  DISH_SIZES = 'DISH_SIZES',
  TOPPINGS = 'TOPPINGS'
}

export { QUERY }

export type { DishModel, DishSizesModel, ToppingsModel }
